export const insertHeader = (textArray, value) => {
  textArray.unshift({
    id: '',
    value,
  });
  return textArray;
};

export const optionsFromText = textArray => textArray.map(text => ({ id: text, value: text }));
